import React from 'react';

import style from './copyright.module.scss';

export const Copyright = () => {
    return (
        <div className={style.copyright}>
            <div className={style.copyrightContent}>
                Copyright 2024 Wintech seals Rubber and Plastics. All Rights Reserved.
            </div>
        </div>
    );
};
